const state = {
    show: false,
    showTimeout: null,
}

const getters = {
    show: state => state.show
}


const mutations = {
    SHOW() {
        clearTimeout(state.showTimeout)
        state.show = true;
        state.showTimeout = setTimeout(() => state.show = false, 1800)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
};
